/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-12 09:20:39
 * @LastEditTime: 2020-06-12 09:20:40
 * @LastEditors:
 */
export default {
  applicationResources: {
    application: '应用',
    selectApplication: '选择应用',
    menu: '菜单',
    menuDetails: '菜单详情',
    menuInformation: '菜单信息',
    menuNumber: '菜单编号',
    menuName: '菜单名称',
    menuIcon: '菜单图标',
    menuUrl: '菜单URL',
    save: '保存',
    buttonName: '按钮名称',
    pageElementNumber: '页面元素编码',
    state: '状态',
    lastUpdated: '更新时间',
    enable: '启动',
    prohibit: '禁用',
    no: '暂无',
    buttonList: '按钮列表',
    pageElementList: '页面元素列表',
    pageElementName: '页面元素名称',

  }
};



// WEBPACK FOOTER //
// ./src/config/langs/zh_CN/applicationResources.js